export const woman = {
  type: 'complex' as const,
  viewBox: "0 0 19.598 26.415",
  elements: [
    {
      type: 'path',
      fill: "#5a4650",
      d: "M4.26 20.45a28 28 0 0 1-2.982-11.4 8.86 8.86 0 0 1 4.686-7.776H8.52V20.45Z"
    },
    {
      type: 'path',
      fill: "#64505a",
      d: "M15.337 20.024s3.408-5.539 3.408-11.077A8.947 8.947 0 0 0 9.798 0h-.847c-2.13 0-3.834 1.335-3.834 2.982a1.7 1.7 0 0 0 1.7 1.7h1.7v15.342h6.817Z"
    },
    {
      type: 'path',
      fill: "#ffe17d",
      d: "M4.686 13.207a.852.852 0 1 1-1.7 0 8.6 8.6 0 0 1 .852-2.556 8.6 8.6 0 0 1 .848 2.556"
    },
    {
      type: 'path',
      fill: "#ffd164",
      d: "M3.834 10.651a8.6 8.6 0 0 0-.852 2.556.85.85 0 0 0 .852.852Z"
    },
    {
      type: 'path',
      fill: "#ffe17d",
      d: "M16.614 13.207a.852.852 0 1 1-1.7 0 8.6 8.6 0 0 1 .852-2.556 8.6 8.6 0 0 1 .848 2.556"
    },
    {
      type: 'path',
      fill: "#ffd164",
      d: "M15.763 10.651a8.6 8.6 0 0 0-.852 2.556.85.85 0 0 0 .852.852Z"
    },
    {
      type: 'path',
      fill: "#e3aa75",
      d: "m17.892 20.701-4.4-1.553a1.7 1.7 0 0 1-1.137-1.607v-2.2H7.243v2.2a1.7 1.7 0 0 1-1.137 1.607l-4.4 1.553a2.56 2.56 0 0 0-1.705 2.411v2.026a1.28 1.28 0 0 0 1.278 1.278h17.04a1.28 1.28 0 0 0 1.278-1.278v-2.026a2.56 2.56 0 0 0-1.705-2.411"
    },
    {
      type: 'path',
      fill: "#d29b6e",
      d: "M9.799 17.042a6.3 6.3 0 0 0 2.556-.545v-1.159H7.243v1.159a6.3 6.3 0 0 0 2.556.545"
    },
    {
      type: 'path',
      fill: "#f5b97d",
      d: "M15.55 8.948h-.213v-1.7a2.556 2.556 0 0 0-2.556-2.556H6.817A2.556 2.556 0 0 0 4.26 7.248v1.7h-.213a1.065 1.065 0 0 0 0 2.13h.235a5.533 5.533 0 0 0 11.034 0h.235a1.065 1.065 0 0 0 0-2.13Z"
    },
    {
      type: 'g',
      fill: "#5a4650",
      children: [
        {
          type: 'path',
          d: "M7.243 10.262a.426.426 0 0 1-.426-.426V9.41a.426.426 0 1 1 .852 0v.426a.426.426 0 0 1-.426.426"
        },
        {
          type: 'path',
          d: "M12.355 10.262a.426.426 0 0 1-.426-.426V9.41a.426.426 0 1 1 .852 0v.426a.426.426 0 0 1-.426.426"
        }
      ]
    },
    {
      type: 'path',
      fill: "#b67f5f",
      d: "M9.798 13.633a2.28 2.28 0 0 1-1.577-.549.427.427 0 0 1 .6-.607 1.73 1.73 0 0 0 1.958 0 .427.427 0 1 1 .6.607 2.28 2.28 0 0 1-1.581.549"
    },
    {
      type: 'g',
      fill: "#a06e50",
      children: [
        {
          type: 'path',
          d: "M6.816 8.544a.426.426 0 0 1-.183-.811l.506-.24a.426.426 0 0 1 .364.77l-.506.24a.4.4 0 0 1-.181.041"
        },
        {
          type: 'path',
          d: "M12.78 8.548a.4.4 0 0 1-.182-.041l-.506-.24a.426.426 0 0 1 .365-.77l.506.24a.426.426 0 0 1-.183.811"
        }
      ]
    },
    {
      type: 'path',
      fill: "#ff8250",
      d: "m17.892 20.701-1-.353a8.923 8.923 0 0 1-14.189 0l-1 .353a2.56 2.56 0 0 0-1.705 2.411v2.026a1.28 1.28 0 0 0 1.278 1.278h17.043a1.28 1.28 0 0 0 1.278-1.278v-2.026a2.56 2.56 0 0 0-1.705-2.411"
    },
    {
      type: 'path',
      fill: "#dc7346",
      d: "M9.799 23.859a8.92 8.92 0 0 1-7.094-3.511l-.848.3a9.794 9.794 0 0 0 15.885 0l-.848-.3a8.92 8.92 0 0 1-7.095 3.511"
    },
    {
      type: 'path',
      fill: "#e3aa75",
      d: "M4.26 7.243v1.7h-.149a1.107 1.107 0 0 0-1.12.955 1.065 1.065 0 0 0 1.06 1.175h.235a5.5 5.5 0 0 0 6.372 5.041 5.535 5.535 0 0 1-4.689-5.467V7.243a1.7 1.7 0 0 1 1.7-1.7h4.686a.85.85 0 0 0 .852-.852h-6.39A2.556 2.556 0 0 0 4.26 7.243"
    }
  ]
} as const
